import i18n from "lib/i18n"
import React from "react"
import PropTypes from "prop-types"
import FormFieldset from "components/FormFieldset"
import { Checkbox } from "components/common/Checkbox"

// The PubliclyRecogniseDonor shows the user an opt-in
// for the donation to be publicly recognised, e.g:
// - Shown on TC's Friends of The Conversation page
// - Given a FoTC badge on their profile

// Internally (in the DB/DW/TC), we store the opposite; if a donation
// is meant to be hidden from the public (or anonymous).

// We set a value of `false` because, if a donation is publicly
// recognised, it's not anonymous.

const PubliclyRecogniseDonor = ({
  active = false,
  onChange = () => {},
  publiclyRecogniseDonor = false,
  formName = "donation",
}) => (
  <FormFieldset>
    <div className="relative flex items-center gap-2">
      <Checkbox
        onChange={onChange}
        value="false"
        type="checkbox"
        id={`${formName}_anonymous`}
        name={`${formName}[anonymous]`}
        checked={publiclyRecogniseDonor}
        disabled={!active}
      >
        <span className="ml-3 text-sm font-medium">
          {i18n.t("donation.label.publicly_recognise_donor")}
        </span>
      </Checkbox>
    </div>
  </FormFieldset>
)

export default React.memo(PubliclyRecogniseDonor)

PubliclyRecogniseDonor.propTypes = {
  active: PropTypes.bool,
  onChange: PropTypes.func,
  publiclyRecogniseDonor: PropTypes.bool,
  formName: PropTypes.string,
}
